import React from 'react';

const Footer = () => <div className="Footer" />;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js